// extracted by mini-css-extract-plugin
export default {"titleButtonUnChecked":"RadioConsumption_titleButtonUnChecked__ooO2Y","titleButtonChecked":"RadioConsumption_titleButtonChecked__zPMT1"};